import type { IconData } from '@stacksjs/iconify-core'

export const mouse: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M448 80a24.027 24.027 0 0 0 24-24V16h-32v32H264a24.027 24.027 0 0 0-24 24v40h-31.375A88.725 88.725 0 0 0 120 200.625v159.946C120 435.247 180.753 496 255.429 496h1.142C331.247 496 392 435.247 392 360.571V200.625A88.725 88.725 0 0 0 303.375 112H272V80ZM152 200.625A56.69 56.69 0 0 1 208.625 144H240v88h-88Zm208 159.946A103.545 103.545 0 0 1 256.571 464h-1.142A103.545 103.545 0 0 1 152 360.571V264h208ZM303.375 144A56.69 56.69 0 0 1 360 200.625V232h-88v-88Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mouse
